module.exports = __webpack_public_path__ + "static/media/RESEARCH_richeyyowell2020.3fcd2025.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/RESEARCH_richeyyowell2020.jpg
// module id = 161
// module chunks = 0